const coins = require('../coins');
const REFERENCE_ASSETS = require('../reference-assets.json');

module.exports = [{
    dataIndex: 0,
    id: '3pool',
    name: '3pool',
    lpTokenInfo: {
        name: '3poolCurve',
        symbol: '3poolCrv',
    },
    assets: 'DAI+USDC+USDT',
    coins: [
        coins.dai,
        coins.usdc,
        coins.usdt,
    ],
    addresses: {
        swap: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
        lpToken: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge: '0x78CF256256C8089d68Cde634Cf7cDEFb39286470',
    },
    isPendingGaugeVoteToStartCrvRewards: true,
    expectedCrvRewardsStart: '1st of July',
    gaugeVersion: 3, // No CRV rewards
  }
];
